import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const Container = styled.section`
  background-color: ${themeGet('colors.bg.primary')};
  display: flex;
  min-height: 100vh;
  /* Using % instead of vw to prevent horizontal scroll */
  width: 100%;
`
